import wrapWithProvider from './wrap-with-provider';

// Refresh the page when service workers are loaded so new content is loaded and shown
export const onServiceWorkerUpdateReady = () => {
  window.location.reload();
};

export const wrapRootElement = wrapWithProvider;
